import { ReactElement } from "react";

import useAuthenticatedUser from "../hooks/useAuthenticatedUser";
import NavigationHeader from "../components/Layout/Header";
import GlobalHeader from "../components/Layout/GlobalHeader";
import useFeatureFlag from "../hooks/useFeatureFlag";

const Header = (): ReactElement | null => {
  const user = useAuthenticatedUser();
  const isGlobalNavigationEnabled = useFeatureFlag("KANRI_ENABLE_GLOBAL_NAVIGATION");
  if (!user) {
    return null;
  }

  return isGlobalNavigationEnabled && user.isEmployee ? (
    <GlobalHeader user={user} />
  ) : (
    <NavigationHeader user={user} />
  );
};

export default Header;
